"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const o=require("./SiteConfig.cjs");function e(){const i=o.default;window.__CODE_STUDIO__||(window.__CODE_STUDIO__=i)}exports.initializeCodeStudioConfig=e;
//# sourceMappingURL=initializeCodeStudioConfig.cjs.map
